/**
 * Water china section: Tween number + scroll visibility (matches Corporate Information introduce page).
 */
(function () {
  if (window.__WaterChinaSectionBoot) return;
  window.__WaterChinaSectionBoot = true;

  function initSection(root) {
    var sid = root.getAttribute('data-water-china-section');
    if (!sid || typeof TWEEN === 'undefined') return;

    var num = document.getElementById('num1-' + sid);
    var numShow = document.getElementById('num1Show-' + sid);
    var testEl = document.getElementById('test-' + sid);
    if (!num || !numShow || !testEl) return;

    function setAnimatedNum(newValue, oldValue, el) {
      function animate(time) {
        requestAnimationFrame(animate);
        TWEEN.update(time);
      }
      new TWEEN.Tween({ tweeningNumber: oldValue })
        .easing(TWEEN.Easing.Quadratic.Out)
        .to({ tweeningNumber: newValue }, 1000)
        .onUpdate(function () {
          el.textContent = this.tweeningNumber.toFixed(0);
        })
        .start();
      animate();
    }

    function handleScroll() {
      var docScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var clientH = window.innerHeight;
      var rect = testEl.getBoundingClientRect();
      var sectionTop1 = rect.top + docScrollTop;
      var sectionH1 = testEl.offsetHeight;
      if (
        docScrollTop + clientH - sectionTop1 >= 0 &&
        docScrollTop - sectionTop1 - sectionH1 <= 0
      ) {
        var target = parseInt(num.textContent, 10);
        var shown = parseInt(numShow.textContent, 10);
        if (target !== shown) {
          setAnimatedNum(target, shown, numShow);
        }
      }
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  function run() {
    document.querySelectorAll('[data-water-china-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
